import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { companyInfo } from '../mockData';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${companyInfo.whatsapp}?text=Hello, I would like to get more information about your epoxy flooring services.`, '_blank');
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="/logo-monarca.png" 
                alt="Monarca Epoxy Design" 
                className="w-12 h-12 object-contain"
              />
              <span className="text-xl font-bold">Monarca Epoxy</span>
            </div>
            <p className="text-slate-400 text-sm mb-4">
              {t('footer.description')}
            </p>
            <button
              onClick={handleWhatsAppClick}
              className="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </button>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/servicios" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  {t('nav.services')}
                </Link>
              </li>
              <li>
                <Link to="/galeria" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  {t('nav.gallery')}
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-slate-400 hover:text-amber-500 transition-colors text-sm">
                  {t('nav.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.servicesTitle')}</h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>{t('footer.industrialFloors')}</li>
              <li>{t('footer.commercialFloors')}</li>
              <li>{t('footer.residentialFloors')}</li>
              <li>{t('footer.parking')}</li>
              <li>{t('footer.maintenance')}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-500">{t('footer.contactTitle')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-sm">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-orange-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Phone className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <div className="flex flex-col gap-1">
                  <a href={`tel:${companyInfo.phone}`} className="text-orange-400 hover:text-orange-300 transition-colors">
                    {companyInfo.phone}
                  </a>
                  <a href={`tel:${companyInfo.phoneAlt}`} className="text-orange-400 hover:text-orange-300 transition-colors">
                    {companyInfo.phoneAlt}
                  </a>
                </div>
              </li>
              <li className="flex items-center space-x-3 text-sm">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-orange-400 hover:text-orange-300 transition-colors break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-sm">
                <Clock className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-orange-400">{t('footer.workingHours')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {currentYear} Monarca Epoxy Design. {t('footer.allRightsReserved')}
          </p>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 z-40"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle className="w-7 h-7 text-white" />
      </button>
    </footer>
  );
};
